import React, {Component} from 'react'
import { connect } from 'react-redux'
import {getUserCSSClass} from '../BobTVUser/index';

import Registry from '../../../registry/index';

import PmWindow from '../PmWindow';

let parentState = {userBlocked:false, meBlocked:false, general:"allowed"}

class PmWindowsList extends Component {
    render() {
        let pmMargin = this.props.pmMargin;
        let conversationsToRender = [];
        for (let i in this.props.pm.conversations) {
            if (this.props.pm.conversations[i].view.hidden) continue;
            conversationsToRender.push(this.props.pm.conversations[i]);
        }
        return (
            <div id="pm-windows" className={`pm-windows ${pmMargin ? 'margin' : ''}`}>
                {conversationsToRender.map( (pmConversation) =>
                    <PmWindow
                        key={pmConversation.user.uid}
                        pmConversation={pmConversation}
                        parentState={parentState}/>
                )}
            </div>
        )
    }

}

function mapStateToProps(state, ownProps) {
    return {
        pm: state.pm
    }
}

export default connect(mapStateToProps)(PmWindowsList);



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/PmWindowsList/index.js